import { Buscador } from '../../Pedido/Buscador';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { UserContext } from '../../../context/UserProvider';
import { useContext, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Button, FormControl, InputLabel, MenuItem, OutlinedInput, Pagination, Select } from '@mui/material';
import { GestionUsuariosContext } from '../../../context/GestionUsuariosContext';
import { handleChangeInputSearch, handleClearInput, handleKeyDown } from '../../../helpers/buscadorHelper';
import { useGetAllUsuariosPaginated } from './useGetAllUsuariosPaginated';
import TableUsuarios from './TableUsuarios';

import CenterUserFilter from './filters/CenterUserFilter';

const GestionUsuarios = () => {
  const { userRole } = useContext(UserContext);
  const { usersPaginated, isLoading, page, setPage } = useGetAllUsuariosPaginated();
  const { statusFilter, setInputAfter, setInputValueSearch, setStatusFilter, centersFilter, setCentersFilter } =
    useContext(GestionUsuariosContext);
  const navigate = useNavigate();

  const handlePagePagination = (event, value = 1) => {
    setPage(value);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(1);
  };

  return (
    <div className="container-master-user">
      <div className="grid-clusters-centers-container">
        <div className="grid-item">
          <h2 style={{ fontWeight: '600' }}>USUARIOS</h2>
        </div>
        <div className="grid-item-clusters-centers-search">
          <Buscador
            value={''}
            width={userRole === 'MasterAdmin' ? '85' : '100'}
            onChange={(e) => handleChangeInputSearch(e, setInputAfter)}
            onKeyDown={(e) => handleKeyDown(e, setInputValueSearch)}
            onClear={() => handleClearInput(setInputValueSearch, setInputAfter)}
          />
          {userRole === 'MasterAdmin' && (
            <Button
              variant="contained"
              color="error"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => navigate('add-users')}
              aria-label="add"
              style={{
                height: '2.5rem',
              }}
            >
              Crear Usuario
            </Button>
          )}
        </div>
      </div>

      <div className="grid-clusters-centers-container">
        <div className="options options-filter">
          <h4 style={{ fontWeight: 'bold' }}>Filtros</h4>
          <FormControl sx={{ maxWidth: 300, marginBottom: 2 }}>
            <InputLabel htmlFor="activeFilter">Filtrar por estado</InputLabel>
            <Select
              id="activeFilter"
              value={statusFilter}
              onChange={handleStatusFilterChange}
              input={<OutlinedInput label="Filtrar por estado" />}
            >
              <MenuItem value="all">
                <em>Todos</em>
              </MenuItem>
              <MenuItem value={false}>Activo</MenuItem>
              <MenuItem value={true}>Inactivo</MenuItem>
            </Select>
            <br />
            <CenterUserFilter centersFilter={centersFilter} setCentersFilter={setCentersFilter} />
          </FormControl>
        </div>

        <div className="grid-item">
          {!isLoading ? (
            <div className="core">
              <TableUsuarios users={usersPaginated?.users} />
            </div>
          ) : (
            <div className="custom-loader"></div>
          )}
        </div>
      </div>

      {usersPaginated?.users?.length > 0 && (
        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
          <Pagination
            showFirstButton
            showLastButton
            page={page}
            onChange={handlePagePagination}
            count={usersPaginated?.pagination?.pages}
            color="error"
            variant="outlined"
            size="large"
            sx={{ margin: '2rem' }}
          />
        </div>
      )}
      <Outlet />
    </div>
  );
};

export default GestionUsuarios;
